import React from "react";
import { graphql } from "gatsby";
import { StaffMembers } from "./StaffMembers";
import {
  KontentComponentLayout,
  KontentComponentSettings,
  KontentLinkedImage,
  KontentMultiChoice,
  StringValue,
  YesNo,
} from "../../../types";
import { getComponentSettings } from "../../../lib/componentSettings";
import { formatImages } from "../../../lib/images";
import { getMultiChoice } from "../../../lib/multichoice";

interface StaffMemberItem {
  id: string;
  elements: {
    first_name: StringValue;
    last_name: StringValue;
    image: KontentLinkedImage;
    title: StringValue;
  };
  system: {
    id: string;
    type: string;
  };
}

interface Props extends KontentComponentLayout, KontentComponentSettings {
  heading: StringValue;
  staff_members: {
    value: StaffMemberItem[];
  };
  show_images: KontentMultiChoice<YesNo>;
}

const StaffMembersContainer: React.FC<Props> = ({
  heading,
  staff_members,
  show_images,
  ...props
}) => {
  const settings = getComponentSettings({ ...props });
  const showImages = getMultiChoice(show_images) !== "no";

  const formatStaffMembers = staff_members.value.map((staffMember, idx) => ({
    firstName: staffMember.elements.first_name.value,
    lastName: staffMember.elements.last_name.value,
    title: staffMember.elements.title.value,
    image: formatImages(staffMember.elements.image.value[0].elements)
      .largeImage,
  }));

  return (
    <StaffMembers
      heading={heading.value}
      staffMembers={formatStaffMembers}
      showImages={showImages}
      {...settings}
    ></StaffMembers>
  );
};

export default StaffMembersContainer;

export const fragmentStaffMembersContainer = graphql`
  fragment StaffMembers on kontent_item_staff_members {
    elements {
      heading {
        value
      }
      staff_members {
        value {
          ... on kontent_item_staff_member_item {
            id
            elements {
              first_name {
                value
              }
              last_name {
                value
              }
              image {
                value {
                  ...kontentImage
                }
              }
              title {
                value
              }
            }
            system {
              id
              type
            }
          }
        }
      }
      show_images {
        value {
          codename
        }
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_layout__component_width {
        value {
          codename
        }
      }
    }
  }
`;
